import api from "./api";

export const onlyOfficeService = {
  async criarSessao(IDArquivo) {
    const resposta = await api.post(
      `/arquivo/${Number(IDArquivo)}/edicao-office/sessao`,
    );
    return resposta.data;
  },
};
